import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { UserDetails } from '../details';
import { WebsiteUsersOverview } from "./overview";
import { WebsiteUserDetails } from "./userDetails";

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class WebsiteUsersPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/website-users/:id(.*)"
            render={component => (
              <WebsiteUserDetails user_id={parseInt(component.match.params.id, 10)} />
            )}
          />

          <Route component={WebsiteUsersOverview} />
        </Switch>
      </Container>
    );
  }
}

WebsiteUsersPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WebsiteUsersPage = compose(
  withConnect,
  withRouter,
)(WebsiteUsersPageComp);
